import { BaseService } from '../base/BaseService';
import type { ServiceResponse } from '../base/ServiceTypes';

import type { UserProfile } from '@/types/user';

class UserService extends BaseService<UserProfile> {
  constructor() {
    super('users'); // 'users' is a placeholder, not a real table for this service
  }

  async updateUserProfile(updates: Partial<UserProfile>): Promise<ServiceResponse<UserProfile>> {
    return this.execute(async () => {
      const {
        data: { user },
        error: getUserError,
      } = await this.client.auth.getUser();
      if (getUserError || !user) {
        throw new Error('User not found');
      }

      const currentMetadata = user.user_metadata || {};
      const newMetadata = { ...currentMetadata, ...updates };

      const { data, error } = await this.client.auth.updateUser({
        data: newMetadata,
      });

      if (error) {
        throw error;
      }

      return data.user as UserProfile;
    });
  }
}

export const userService = new UserService();
